export default "__VITE_ASSET__Z$4y8SS0__"